import ScrollAnimation from '../../../../utils/ScrollAnimation';
import privateGatewayImg from '../../../../assets/imgs/home/00_privateGateway/private_gateway.png';
import michelinBadge from '../../../../assets/michelin/MICHELIN_Selected_2026_Rectangle_Red.png';
import privateGatewayPdf from '../../../../assets/documents/home/00_privateGateway/Cornaro Booklet 2026.pdf';

const PrivateGateway = () => {
  return (
    <div className='privateGateway'>
      <div className='privateGateway_container container'>
        <ScrollAnimation
          animateIn='fadeInUp'
          delay={100}
          className='privateGateway_container_item privateGateway_container_item_media'
        >
          <div className='privateGateway_container_media'>
            <img src={privateGatewayImg} alt='private gateway' />
          </div>
          <div className='privateGateway_container_michelin'>
            <img
              src={michelinBadge}
              alt='Hotel Selection MICHELIN Guide 2026'
            />
            <div className='privateGateway_container_michelin_text'>
              <span>CORNARO HOTEL SPLIT</span>
              <p>
                A MICHELIN Guide Featured Hotel.
                <br />
                Your curated luxury stay in Split.
              </p>
            </div>
          </div>
        </ScrollAnimation>
        <div className='privateGateway_container_text privateGateway_container_item privateGateway_container_item_text'>
          <ScrollAnimation animateIn='fadeInUp' delay={150}>
            <h2 className='title_underline_light'>
              YOUR PRIVATE GATEWAY TO THE SOUL OF SPLIT
            </h2>
            <div
              className='privateGateway_container_stars'
              role='img'
              aria-label='5 stars'
            >
              {'\u2605'.repeat(5)}
            </div>
            <p>Explore the Cornaro State of Mind</p>
            <a
              href={privateGatewayPdf}
              target='_blank'
              rel='noreferrer'
              className='opacity_transition_low button'
            >
              <div>EXPLORE</div>
            </a>
          </ScrollAnimation>
        </div>
      </div>
    </div>
  );
};

export default PrivateGateway;
